import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TAB_ROUTES = [
  { path: "dashboard", label: "Dashboard", index: 0 },
  { path: "flows", label: "Flows", index: 1 },
  { path: "generate", label: "Generate Documents", index: 2 },
  { path: "templates", label: "Templates", index: 3 },
] as const;

export interface UseFlowsAutomationsPageReturn {
  activeTab: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export function useFlowsAutomationsPage(): UseFlowsAutomationsPageReturn {
  const location = useLocation();
  const navigate = useNavigate();

  // Derive current tab directly from URL - URL is the single source of truth
  const activeTab = useMemo(() => {
    const pathSegments = location.pathname.split("/");
    const tabPath = pathSegments[2]; // /flows-automations/{tabPath}
    const tabRoute = TAB_ROUTES.find((t) => t.path === tabPath);
    return tabRoute?.index ?? 0;
  }, [location.pathname]);

  // Handle tab change - navigate to update URL
  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      const tabRoute = TAB_ROUTES.find((t) => t.index === newValue);
      if (tabRoute) {
        navigate(`/flows-automations/${tabRoute.path}`);
      }
    },
    [navigate]
  );

  return useMemo(
    () => ({
      activeTab,
      handleTabChange,
    }),
    [activeTab, handleTabChange]
  );
}
